import React from 'react';
import { Button, Dropdown, Icon, Menu } from 'antd';
import styled from 'styled-components';

var ToolbarContainer = styled.div`
    position: fixed;
    bottom: 24px;
    left: 50%;
    transform: translateX(-50%);
    background: ${function(props) { return props.background || '#722ed1'; }};
    padding: 12px 24px;
    border-radius: 8px;
    box-shadow: 0 4px 12px ${function(props) { return props.shadowColor || 'rgba(114, 46, 209, 0.4)'; }};
    display: flex;
    align-items: center;
    gap: 16px;
    z-index: 1000;
`;

var SelectionText = styled.span`
    color: #fff;
    font-weight: 500;
`;

var ClearButton = styled(Button)`
    color: rgba(255, 255, 255, 0.85) !important;

    &:hover {
        color: #fff !important;
    }
`;

var ActionButton = styled(Button)`
    border-color: #fff !important;
    color: #fff !important;
    background: transparent !important;

    &:hover {
        border-color: rgba(255, 255, 255, 0.8) !important;
        color: rgba(255, 255, 255, 0.8) !important;
        background: rgba(255, 255, 255, 0.1) !important;
    }
`;

var DangerActionButton = styled(Button)`
    border-color: #ff7875 !important;
    color: #ff7875 !important;
    background: transparent !important;

    &:hover {
        border-color: #ffa39e !important;
        color: #ffa39e !important;
        background: rgba(255, 255, 255, 0.1) !important;
    }
`;

/**
 * SelectionToolbar - Floating toolbar for bulk actions on selected items
 *
 * @param {Object} props
 * @param {number} props.count - Number of selected items
 * @param {function} props.onClear - Called when clear selection is clicked
 * @param {Array} props.actions - Array of action objects: { label, icon, onClick, danger }.
 *   With `menu` ([{ key, label, danger, children }]) the button opens a dropdown and
 *   `onClick` receives the chosen key.
 * @param {string} props.itemLabel - Label for items (default: "item")
 * @param {string} props.background - Background color (default: purple #722ed1)
 * @param {string} props.shadowColor - Box shadow color
 * @param {node} props.extra - Optional content after the count (e.g. "select all N")
 */
var SelectionToolbar = function(props) {
    var count = props.count;
    var onClear = props.onClear;
    var actions = props.actions || [];
    var itemLabel = props.itemLabel || 'item';
    var background = props.background;
    var shadowColor = props.shadowColor;

    if (!count || count === 0) {
        return null;
    }

    var itemText = count === 1 ? itemLabel : itemLabel + '(s)';

    return (
        <ToolbarContainer background={background} shadowColor={shadowColor}>
            <SelectionText>
                {count} {itemText} selecionado{count !== 1 ? 's' : ''}
            </SelectionText>

            {props.extra}

            {onClear && (
                <ClearButton type="link" onClick={onClear}>
                    Limpar
                </ClearButton>
            )}

            {actions.map(function(action, index) {
                var ButtonComponent = action.danger ? DangerActionButton : ActionButton;
                if (action.menu) {
                    var renderItem = function(item) {
                        if (item.children) {
                            return (
                                <Menu.SubMenu key={item.key} title={item.label}>
                                    {item.children.map(renderItem)}
                                </Menu.SubMenu>
                            );
                        }
                        return (
                            <Menu.Item key={item.key} style={item.danger ? { color: '#cf1322' } : undefined}>
                                {item.icon && <Icon type={item.icon} />} {item.label}
                            </Menu.Item>
                        );
                    };
                    return (
                        <Dropdown
                            key={index}
                            trigger={['click']}
                            placement="topCenter"
                            overlay={
                                <Menu onClick={function(e) { action.onClick(e.key); }}>
                                    {action.menu.map(renderItem)}
                                </Menu>
                            }
                        >
                            <ButtonComponent ghost icon={action.icon} loading={action.loading || false}>
                                {action.label} <Icon type="up" />
                            </ButtonComponent>
                        </Dropdown>
                    );
                }
                return (
                    <ButtonComponent
                        key={index}
                        ghost
                        icon={action.icon}
                        onClick={action.onClick}
                        loading={action.loading || false}
                    >
                        {action.label}
                    </ButtonComponent>
                );
            })}
        </ToolbarContainer>
    );
};

export default SelectionToolbar;
